import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "award-1",
  "use": "award-1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"award-1\"><defs><style type=\"text/css\"></style></defs><path d=\"M160 0h704a128 128 0 0 1 128 128v768a128 128 0 0 1-128 128H160a128 128 0 0 1-128-128V128a128 128 0 0 1 128-128z m0 128v192h704V128H160z m64 384a64 64 0 1 0 0-128 64 64 0 0 0 0 128z m192 0a64 64 0 1 0 0-128 64 64 0 0 0 0 128z m192 0a64 64 0 1 0 0-128 64 64 0 0 0 0 128z m192 0a64 64 0 1 0 0-128 64 64 0 0 0 0 128z m0 64a64 64 0 0 0-64 64v192a64 64 0 0 0 128 0v-192a64 64 0 0 0-64-64z m-576 128a64 64 0 1 0 0-128 64 64 0 0 0 0 128z m192 0a64 64 0 1 0 0-128 64 64 0 0 0 0 128z m192 0a64 64 0 1 0 0-128 64 64 0 0 0 0 128z m-384 192a64 64 0 1 0 0-128 64 64 0 0 0 0 128z m192 0a64 64 0 1 0 0-128 64 64 0 0 0 0 128z m192 0a64 64 0 1 0 0-128 64 64 0 0 0 0 128z\" p-id=\"2286\" fill=\"#29A1F7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/award-1.svg
// module id = DcXP
// module chunks = 38